/* 
 *  Created by RRamireddygari 02/14/2018
 */

export class RepoFolder {

    folderId: number;
    folderName: string;

    constructor(id: number, name: string) {
        this.folderId = id;
        this.folderName = name;
    }

}


// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/model/repofolder.ts